import { render } from "./RegisterComplete.vue?vue&type=template&id=5ca3e1b2&scoped=true"
import script from "./RegisterComplete.vue?vue&type=script&lang=js"
export * from "./RegisterComplete.vue?vue&type=script&lang=js"

import "./RegisterComplete.vue?vue&type=style&index=0&id=5ca3e1b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca3e1b2"]])

export default __exports__